<template>
    <el-select v-bind="$attrs" :value="value" @change="change">
        <el-option
                v-for="{value, label} in options"
                :key="value"
                :label="label"
                :value="value">
        </el-option>
    </el-select>
</template>

<script>
  export default {
    props: {
      value: null,
    },

    data() {
      return {
        options: [
          {value: 1, label: '1 day'},
          {value: 2, label: '2 days'},
          {value: 3, label: '3 days'},
          {value: 4, label: '4 days'},
          {value: 5, label: '5 days'},
          {value: 6, label: '6 days'},
          {value: 7, label: '7 days'},
          {value: 14, label: '14 days'},
          {value: 21, label: '21 days'},
          {value: 30, label: '30 days'},
          {value: 60, label: '60 days'},
          {value: 90, label: '90 days'},
        ],
      };
    },

    methods: {


      change(val) {
        this.$emit('input', val);
      },
    },

  }
</script>
